// ─────────────────────────────────────────────────────────────────────────────
// Cloudinary delivery optimisation
//
// Product images are uploaded to Cloudinary but the storefront historically
// rendered the raw `secure_url` (full-size original). This helper injects
// on-the-fly transformations after the "/upload/" segment so cards/thumbs get
// correctly sized, auto-format (WebP/AVIF), auto-quality images. Non-Cloudinary
// URLs are returned untouched so nothing breaks.
// ─────────────────────────────────────────────────────────────────────────────

// c_fit (not c_fill) preserves the whole product — no cropping — so packets,
// bottles and book covers display in full inside a contain'd card image area.
const PRESETS = {
  card: "f_auto,q_auto,w_500,h_500,c_fit",
  card2x: "f_auto,q_auto,w_1000,h_1000,c_fit",
  thumb: "f_auto,q_auto,w_160,h_160,c_fit",
  hero: "f_auto,q_auto,w_1280,h_420,c_fill",
};

const UPLOAD_MARKER = "/upload/";

const inject = (url, transform) => {
  if (!url || typeof url !== "string") return url || "";
  const i = url.indexOf(UPLOAD_MARKER);
  if (i === -1) return url; // not a standard Cloudinary upload URL
  const head = url.slice(0, i + UPLOAD_MARKER.length);
  const tail = url.slice(i + UPLOAD_MARKER.length);
  return `${head}${transform}/${tail}`;
};

export const optimizedImage = (url, preset = "card") =>
  inject(url, PRESETS[preset] || PRESETS.card);

// 1x/2x srcSet for crisp images on retina screens (card preset only).
export const optimizedSrcSet = (url, preset = "card") => {
  if (!url || typeof url !== "string" || url.indexOf(UPLOAD_MARKER) === -1) {
    return undefined;
  }
  if (preset !== "card") return undefined;
  return `${inject(url, PRESETS.card)} 1x, ${inject(url, PRESETS.card2x)} 2x`;
};

export default optimizedImage;
